import { createActionHelpers } from 'vuex-loading';
import { findLast } from 'lodash';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    outletList: [],
    lastQuery: null,
    outlet: {
        id: null,
        name: null,
        address: null,
        media_urls: [],
        centrals: [],
        pricebook: [],
        latitude: null,
        longitude: null,
        taxes: [],
        preference: {
            currency: [],
            timezone: [],
            phone: null,
            operation_hours: [],
        },
    },
};

const getters = {
    outletList: state => {
        return state.outletList;
    },
    outlet: state => state.outlet,
    outletImage: state => {
        if (!state.outlet.media_urls.length) {
            return '/img/slurp-500.png';
        }

        return findLast(state.outlet.media_urls).s512;
    },
};

const mutations = {
    setOutlet(state, outlet) {
        state.outlet = outlet;
    },

    setOutletList(state, data) {
        state.outletList = data;
    },

    setOutletTaxes(state, taxes) {
        state.outlet.taxes = taxes;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    findOutlets({ commit, dispatch }, params) {
        let options = {
            params: params,
        };

        let outlets = state.outletList.filter(o => {
            return params.ids.includes(o.id);
        });

        if (outlets.length === params.ids.length) {
            return Promise.resolve(outlets);
        }

        startLoading(dispatch, 'find-outlets');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                endLoading(dispatch, 'find-outlets');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-outlets');
                throw err;
            });
    },

    getOutletListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.outletList.length || state.lastQuery !== params.query) {
            dispatch('getOutletList', params);
        }
    },

    getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-outlet');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                let data = res.data.data;

                commit('setOutletList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-outlet');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-outlet');
                throw err;
            });
    },

    async getOutlet({ dispatch, commit }, id) {
        startLoading(dispatch, 'fetch-outlet');
        const url = Laroute.route('franchise.outlet.show', { id });

        try {
            const { data } = await axios.get(url);
            commit('setOutlet', data);
            endLoading(dispatch, 'fetch-outlet');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-outlet');
            throw e;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/outlet.js